import { createFileRoute } from '@tanstack/react-router';
import { startOfMonth, endOfMonth, startOfDay } from 'date-fns';
import * as z from 'zod/v4';
import { zodValidator } from '@tanstack/zod-adapter';
import { parseEnv } from '@/helpers/route-utils';
import { filtersSchema } from '@/helpers/build-get-events-filter';

const searchSchema = z.object({
  range: z
    .tuple([z.coerce.date(), z.coerce.date()])
    .optional()
    .default([startOfDay(startOfMonth(new Date())), startOfDay(endOfMonth(new Date()))]),
  viewType: z.enum(['month', 'week', 'day', 'calendar']).optional().default('month'),
  search: z.string().optional(),
  filters: filtersSchema.optional(),
});

export const Route = createFileRoute('/_auth/$env/scheduler')({
  validateSearch: zodValidator(searchSchema),
  params: parseEnv(),
});
